import { post } from "@utils/https";

const handleGetSource = () => {
  return post({
    url: "/publish/findResourceTotal",
  });
};

export { handleGetSource };
